var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebProfileCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9EDFF",
  d: "M20 100a80 80 0 1 0 160 0 80 80 0 1 0-160 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  d: "M41.184 45.756h107.93v88.78H41.184Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M142.152 45.756h-94a6.96 6.96 0 0 0-6.964 6.962v13.926h107.926V52.718a6.96 6.96 0 0 0-6.962-6.962"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M41.184 45.756h107.93v88.78H41.184Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M142.152 45.754h-94a6.964 6.964 0 0 0-6.964 6.964v13.926h107.926V52.718a6.964 6.964 0 0 0-6.962-6.964Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M48.148 56.2a3.482 3.482 0 1 0 6.964 0 3.482 3.482 0 1 0-6.964 0Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M62.074 56.2a3.482 3.482 0 1 0 6.964 0 3.482 3.482 0 1 0-6.964 0"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M76 56.2a3.482 3.482 0 1 0 6.964 0 3.482 3.482 0 1 0-6.964 0Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M54.526 73.952h34.8v47.454h-34.8Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M62.436 92.934a9.49 9.49 0 1 0 18.98 0 9.49 9.49 0 1 0-18.98 0Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M99.642 80.142h18.34M99.642 103.066h29.802M99.642 91.604h25.218M99.642 114.53h25.218"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M54.526 118.98a17.422 17.422 0 0 1 34.8 0v.22a2.2 2.2 0 0 1-2.2 2.2H56.732a2.2 2.2 0 0 1-2.2-2.2Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  d: "M126 156.666c0-1.668-13.342-3.024-29.8-3.024s-29.8 1.356-29.8 3.024 13.344 3.024 29.8 3.024 29.8-1.352 29.8-3.024"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M114.94 121.012a29.802 29.802 0 1 0 59.604 0 29.802 29.802 0 1 0-59.604 0"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0D9FF",
  stroke: "#020064",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M138.712 135.718a4.33 4.33 0 0 1-3.068-1.27l-8.678-8.68a4.339 4.339 0 1 1 6.136-6.136l5.6 5.612 17.668-17.668a4.339 4.339 0 0 1 6.136 6.136l-20.726 20.736a4.33 4.33 0 0 1-3.068 1.27"
})));
export default SvgWebProfileCheck;